var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.visibility},[_c('IconButton',{class:_vm.$style.button,attrs:{"data-test-id":"HeaderItemProductTour__button","hasNoBackground":"","icon":"discover","text":_vm.title,"type":"secondary"},on:{"click":_vm.handleLaunchProductTour}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }